var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6821 5.08698C7.6174 6.06174 7.668 7.04509 7.668 8.04994H11.3806C11.2147 9.36681 11.0571 10.6536 10.8937 11.9713H7.6539V22H3.75554V11.9877H0.5V8.05681H3.74808V7.77574C3.75222 6.75886 3.72817 5.74111 3.76798 4.72509C3.81609 3.5002 4.16114 2.37415 4.98974 1.4587C5.69891 0.672192 6.59139 0.255299 7.60247 0.0954174C8.73299 -0.0764979 9.86435 0.0361075 10.9949 0.117767C11.1608 0.129801 11.3266 0.14785 11.5 0.163322V3.66352C11.1981 3.66352 10.9028 3.66352 10.6075 3.66352C10.1032 3.67126 9.5981 3.66352 9.09546 3.69962C8.2146 3.75549 7.74348 4.17153 7.6821 5.08698Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.fd17467d0a12f31f51374d8a37a8c31c.svg";
export { ForwardRef as ReactComponent };